import React, { useEffect } from 'react';
import { TableActionTypes, TableState } from 'web-library';

interface IUseDataTableFEPagination {
  dataList: any[];
  tableState: TableState;
  tableDispatch: React.Dispatch<TableActionTypes>;
}
const useDataTableFEPagination = ({
  dataList,
  tableState,
  tableDispatch,
}: IUseDataTableFEPagination) => {
  useEffect(() => {
    if (dataList.length > 0) {
      const sliceBeginIndex = tableState.page * tableState.size;
      const sliceEndIndex = sliceBeginIndex + tableState.size;
      tableDispatch(({
        type: 'UPDATE_DATA',
        payload: {
          data: dataList.slice(sliceBeginIndex, sliceEndIndex),
          count: dataList.length,
        },
      } as unknown) as TableActionTypes);
    }
  }, [tableState.page, tableState.order, tableState.size, dataList, tableDispatch]);
};

export default useDataTableFEPagination;
